import { createBrowserRouter, Navigate, RouterProvider } from 'react-router'
import { FTUPage } from './authentication/FTUPage'
import { ForgotPasswordPage } from './authentication/forgotPassword/ForgotPasswordPage'
import { PasswordResetedPage } from './authentication/forgotPassword/PasswordResetedPage'
import { LoginPage } from './authentication/login/LoginPage'
import { VerifyPage } from './authentication/login/VerifyPage'
import { PasswordChangedPage } from './authentication/passwordChanged/PasswordChangedPage'
import { ResetPasswordPage } from './authentication/resetPassword/ResetPasswordPage'
import { TokenExpiredPage } from './authentication/tokenExpired/TokenExpiredPage'

import ErrorPage from './genericComponents/ErrorPage'
import { VerifyEmail } from './authentication/emailVerified/VerifyEmail'

const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },

  {
    path: '/forgot_pw',
    element: <ForgotPasswordPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/pw_resetted',
    element: <PasswordResetedPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/maintenance/verify_email',
    element: <VerifyEmail />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/ftu',
    element: <FTUPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/verify',
    element: <VerifyPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/reset_password',
    element: <ResetPasswordPage mode="resetPassword" />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/password_changed',
    element: <PasswordChangedPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/token_expired',
    element: <TokenExpiredPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/user_maintenance_complete',
    element: <Navigate to="/" />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/enable_account',
    element: <ResetPasswordPage mode="enableUser" />,
    errorElement: <ErrorPage />,
  },
  //not 100% sure if anything anymore routes to these pages from back end but doesnt cost us anything to have these mapped here
  {
    path: '/error',
    element: <ErrorPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/access_denied',
    element: <ErrorPage />,
    errorElement: <ErrorPage />,
  },
])

export const AnonymousRouterIndex = () => <RouterProvider router={router} />
